var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-left w3-button w3-black w3-margin",on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-file-excel-o"}),_vm._v(" Export to Excel ")])}
var staticRenderFns = []

export { render, staticRenderFns }